// extracted by mini-css-extract-plugin
export default {"newRecipeCard":"NewRecipe_newRecipeCard__vnr9v","newRecipeBtn":"NewRecipe_newRecipeBtn__BTOMA","btnLabel":"NewRecipe_btnLabel__nlwPz","icon":"NewRecipe_icon__GBB4t"};